export const getCourtSchedulerConfigForTheDay = (axiosInstance, eventId, params) => {
    return axiosInstance.get(`v2/tms/events/${eventId}/schedule/day-config`, {
        params: {
            date: params.date,
        },
    });
};

export const getDefaultCourtSchedulerConfig = (axiosInstance, eventId) => {
    return axiosInstance.get(`v2/tms/events/${eventId}/schedule/day-config/default`);
};

export const saveCourtSchedulerConfig = (axiosInstance, eventId, params) => {
    return axiosInstance.post(`v2/tms/events/${eventId}/schedule/day-config`, params);
};

export const getDrawMatchCounts = (axiosInstance, eventId) => {
    return axiosInstance.get(`/v2/tms/events/${eventId}/schedule/oop/draws/match-counts`);
};

export const getUnscheduledMatchesForDraw = (axiosInstance, eventId, drawId) => {
    return axiosInstance.get(`/v2/tms/events/${eventId}/schedule/oop/draws/${drawId}/unscheduled`);
};

export const getScheduledMatchesForEvent = (axiosInstance, eventId, params) => {
    return axiosInstance.get(`/v2/tms/events/${eventId}/schedule/oop`, {
        params,
    });
};

export const getScheduledMatchesForEventV3 = (axiosInstance, eventId, params) => {
    return axiosInstance.get(`/v3/tms/events/${eventId}/schedule/oop`, {
        params,
    });
};

export const getUnscheduledMatchesForDrawV3 = (axiosInstance, eventId, drawId) => {
    return axiosInstance.get(`/v3/tms/events/${eventId}/schedule/oop/draws/${drawId}/unscheduled`);
};

export const scheduleMatchForEvent = (axiosInstance, eventId, params) => {
    return axiosInstance.post(`/v2/tms/events/${eventId}/schedule/oop`, params);
};

export const publishScheduleForEvent = (axiosInstance, eventId, params) => {
    return axiosInstance.post(`/v2/tms/events/${eventId}/schedule/oop/publish`, params);
};

export const revertScheduleForEvent = (axiosInstance, eventId, params) => {
    return axiosInstance.post(`/v2/tms/events/${eventId}/schedule/oop/revert`, params);
};

export const updateMatchSettings = (axiosInstance, eventId, matchId, params) => {
    return axiosInstance.put(`/v2/tms/events/${eventId}/schedule/oop/${matchId}`, params);
};

export const deScheduleMatches = (axiosInstance, eventId, params) => {
    return axiosInstance.post(`/v2/tms/events/${eventId}/schedule/oop/delete`, params);
};

export const startMatches = (axiosInstance, eventId, params) => {
    return axiosInstance.put(`/v2/tms/events/${eventId}/schedule/matches/start`, params);
};

export const pauseMatches = (axiosInstance, eventId, params) => {
    return axiosInstance.put(`/v2/tms/events/${eventId}/schedule/matches/pause`, params);
};

export const adjustMatches = (axiosInstance, eventId, params) => {
    return axiosInstance.put(`/v2/tms/events/${eventId}/schedule/matches/adjust`, params);
};

export const restartMatch = (axiosInstance, eventId, matchId) => {
    return axiosInstance.put(`/v2/tms/events/${eventId}/schedule/matches/${matchId}/restart`);
};
